import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ShippingLineForm } from '@/components/forms/ShippingLineForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditShippingLinePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined

  const handleSuccess = () => {
    navigate('/shipping-lines')
  }

  const handleCancel = () => {
    navigate('/shipping-lines')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Shipping Line
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Shipping Line details
            </Text>
          </CardHeader>
          <CardBody>
            <ShippingLineForm shippingLineId={numericId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


